export function BreakIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="currentColor"
            aria-hidden="true"
        >
            <path d="M4.8014 11.1984H9.6014C10.9264 11.1984 12.0014 10.1234 12.0014 8.79844H12.8014C14.5664 8.79844 16.0014 7.36344 16.0014 5.59844C16.0014 3.83344 14.5664 2.39844 12.8014 2.39844H3.0014C2.6689 2.39844 2.4014 2.66594 2.4014 2.99844V8.79844C2.4014 10.1234 3.4764 11.1984 4.8014 11.1984ZM12.8014 3.99844C13.6839 3.99844 14.4014 4.71594 14.4014 5.59844C14.4014 6.48094 13.6839 7.19844 12.8014 7.19844H12.0014V3.99844H12.8014ZM13.9939 13.5984H1.2089C0.0188979 13.5984 -0.316102 11.9984 0.308898 11.9984H14.8914C15.5164 11.9984 15.1864 13.5984 13.9939 13.5984Z" />
        </svg>
    );
}
